import { ToggleButton } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyledToggleButtonGroup } from 'src/components/OrderSelect'

const tabs = [
  ['artwork', 'user:profile-sub-tab.artwork'],
  // @deprecated at 2025-07-23
  // ['manga', 'user:profile-sub-tab.comic'],
  ['animation', 'common:animation.label_other'],
  ['model', 'user:profile-sub-tab.model'],
] as const

export type WorkTypes = (typeof tabs)[number][0]

// FIXME: "Work" represents all the things that users can generate or consume.
//        It's not a good name (considering its multiple definitions).
//        Need a better replacement.
export default function WorkTypeTabs(
  props: StyleProps & {
    accept?: WorkTypes[]
    value: WorkTypes | ''
    onChange: (value: WorkTypes | '') => void
  },
) {
  const { t } = useTranslation(['user'])

  const tabs$ = useMemo(
    () =>
      tabs.filter(([value]) => !props.accept || props.accept.includes(value)),
    [props.accept],
  )

  return (
    <StyledToggleButtonGroup
      value={props.value}
      onChange={(_, value: WorkTypes | null) => {
        props.onChange(value ?? '')
      }}
      size="small"
      exclusive
      className={props.className}
      style={props.style}
    >
      {tabs$.map(([value, label]) => (
        <ToggleButton key={value} value={value}>
          <span className="normal-case inline-flex items-center">
            {t(label)}
          </span>
        </ToggleButton>
      ))}
    </StyledToggleButtonGroup>
  )
}
